import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "navbar",
  type: "dark",
  id: "main-navbar"
}
const _hoisted_2 = {
  class: "navbar-brand",
  href: "javascript:void(0)"
}
const _hoisted_3 = { class: "icons" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "fab-icons"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]

import {useRouter} from "vue-router";
import {useStore} from "vuex";
import {useI18n} from "vue-i18n";
import {onBeforeUnmount, onMounted, Prop, ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppActivity',
  props: {
    title: {},
    vertical: { default: 'top' },
    fullSize: { type: Boolean, default: false },
    icons: {},
    fabIcons: {}
  },
  emits: ["iconClick", "fabIconClick"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const { t } = useI18n()
const store = useStore()
const router = useRouter()

const contentContainer = ref<HTMLElement|null>(null)
const contentFooterContainer = ref<HTMLElement|null>(null)
const footerContainer = ref<HTMLElement|null>(null)

const isLogin = router.currentRoute.value.name === 'Forbidden'

const onLogout = () => {
  store.dispatch('AUTH_LOGOUT')
  router.push({ name: 'Forbidden' })
}

const onIconClick = (icon: string) => emit('iconClick', icon)
const onFabIconClick = (icon: string) => emit('fabIconClick', icon)

const checkFooterHeight = () => {
  if (contentContainer.value) {
    const height = contentFooterContainer.value?.getBoundingClientRect().height
    const height2 = footerContainer.value?.getBoundingClientRect().height

    let space = 0
    if (height) {
      space += height
    }
    if (height2) {
      space += height2
    }

    contentContainer.value.style.paddingBottom = `${space}px`
  }
}

onMounted(() => {
  checkFooterHeight()
  window.addEventListener('resize', checkFooterHeight)
})
onBeforeUnmount(() => {
  window.removeEventListener('resize', checkFooterHeight)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["activity", `valign-${_ctx.vertical}`])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.icons, (icon) => {
          return (_openBlock(), _createElementBlock("li", { key: icon }, [
            _createElementVNode("a", {
              href: "javascript:void(0);",
              onClick: () => onIconClick(icon)
            }, [
              _createElementVNode("img", { src: icon }, null, 8, _hoisted_5)
            ], 8, _hoisted_4)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["container", { 'without-space': _ctx.fullSize }])
    }, [
      _createElementVNode("div", {
        class: "content",
        ref_key: "contentContainer",
        ref: contentContainer
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 512),
      _createElementVNode("div", {
        class: "content-footer",
        ref_key: "contentFooterContainer",
        ref: contentFooterContainer
      }, [
        _renderSlot(_ctx.$slots, "content-footer")
      ], 512)
    ], 2),
    (_ctx.fabIcons)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fabIcons, (icon) => {
            return (_openBlock(), _createElementBlock("li", { key: icon }, [
              _createElementVNode("a", {
                href: "javascript:void(0)",
                onClick: () => onFabIconClick(icon)
              }, [
                _createElementVNode("img", { src: icon }, null, 8, _hoisted_8)
              ], 8, _hoisted_7)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("footer", {
      ref_key: "footerContainer",
      ref: footerContainer
    }, [
      _renderSlot(_ctx.$slots, "footer")
    ], 512)
  ], 2))
}
}

})